import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { PersonalAndCreditInformation } from './personalAndCreditInformation';
import { useStore } from '@roc/client-portal-shared/hooks';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type PersonalAndCreditInformationDialogProps = {
  open: boolean;
  borrowerId: number;
  loan?: any;
  handleClose: () => void;
  refreshLoan?: () => void;
  document: Document;
};

export const PersonalAndCreditInformationDialog = observer((props: PersonalAndCreditInformationDialogProps) => {
  const { open, borrowerId, loan, handleClose, refreshLoan, document } = props;
  const taskId = document?.taskId;

  const { borrowerSetupToDoStore } = useStore();
  const onClose = () => {
    borrowerSetupToDoStore.reset();
    handleClose();
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          maxWidth={'lg'}
          open={open}
          title={'Authorization'}
          handleClose={onClose}
          dialogContent={
            <PersonalAndCreditInformation
              borrowerId={borrowerId}
              loan={loan}
              handleClose={onClose}
              refreshLoan={refreshLoan}
              document={document}
            />
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          maxWidth={'lg'}
          open={open}
          title={'Authorization'}
          handleClose={onClose}
          dialogContent={
            <PersonalAndCreditInformation
              borrowerId={borrowerId}
              loan={loan}
              handleClose={onClose}
              refreshLoan={refreshLoan}
              document={document}
            />
          }
          removeContentBox
        />
      )}
    </>
  );
});

export default PersonalAndCreditInformationDialog;